import React from "react";

export const About: React.FC = () => {
  return (
    <div id="about" className="about-section">
      <div className="about-images">
        <div className="about-image-container about-image-first">
          <img 
            src="img/img5.webp" 
            alt="Fundadora Endocomunidad" 
            className="about-image"
          />
        </div>
        <div className="about-image-container about-image-second">
          <img 
            src="img/img6.webp" 
            alt="Fundadora Endocomunidad" 
            className="about-image"
          />
        </div>
      </div>
      <div className="about-overlay"></div>
      <div className="about-content">
        <h1 className="about-quote">
          "QUE LA SALUD NO SEA UN PRIVILEGIO PARA POCOS"
        </h1>
        <p className="about-attribution">
          -Lula, Fundadora de Endocomunidad
        </p>
      </div>
    </div>
  );
};

